import React, { useState } from "react";
import {
  BiFile,
  BiMoney,
  BiCheckShield,
  BiBulb,
  BiBarChartAlt2,
  BiTrendingUp,
} from "react-icons/bi";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import ClipLoader from "react-spinners/ClipLoader";
import Header from "../header/header";
import NavBar from "../nav/nav-bar";
import Footer from "../footer/footer";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import Masonry from "react-masonry-css";

function LobHome() {
  const [collectionFilter, setCollectionFilter] = useState("Team");
  const [complianceFilter, setComplianceFilter] = useState("Team");

  const [collectionLoading, setCollectionLoading] = useState(false);
  const [complianceLoading, setComplianceLoading] = useState(false);
  const [strategyScoreLoading, setStrategyScoreLoading] = useState(false);
  const [strategyScoreFilter, setStrategyScoreFilter] =
    useState("Organization");
  const [trendsLoading, setTrendsLoading] = useState(false);
  const [trendsFilter, setTrendsFilter] = useState("Daily");
  const [cxTrendsLoading, setCxTrendsLoading] = useState(false);
  const [cxTrendsFilter, setCxTrendsFilter] = useState("Organization");
  const [intentLoading, setIntentLoading] = useState(false);
  const [intentFilter, setIntentFilter] = useState("Organization");

  const handleCollectionChange = (e) => {
    setCollectionLoading(true);
    setCollectionFilter(e.target.value);
    setTimeout(() => {
      setCollectionLoading(false);
    }, 200);
  };

  const handleComplianceChange = (e) => {
    setComplianceLoading(true);
    setComplianceFilter(e.target.value);
    setTimeout(() => {
      setComplianceLoading(false);
    }, 200);
  };

  const handleStrategyScoreChange = (e) => {
    setStrategyScoreLoading(true);
    setStrategyScoreFilter(e.target.value);
    setTimeout(() => {
      setStrategyScoreLoading(false);
    }, 200);
  };

  const handleTrendsChange = (e) => {
    setTrendsLoading(true);
    setTrendsFilter(e.target.value);
    setTimeout(() => {
      setTrendsLoading(false);
    }, 200);
  };

  const handleCxTrendsChange = (e) => {
    setCxTrendsLoading(true);
    setCxTrendsFilter(e.target.value);
    setTimeout(() => {
      setCxTrendsLoading(false);
    }, 200);
  };

  const handleIntentChange = (e) => {
    setIntentLoading(true);
    setIntentFilter(e.target.value);
    setTimeout(() => {
      setIntentLoading(false);
    }, 200);
  };

  const recentReportsData = [
    {
      rate: "85%",
      count: 124,
      collected: "₹45,000",
      target: "₹50,000",
    },
    {
      rate: "92%",
      count: 98,
      collected: "₹38,000",
      target: "₹40,000",
    },
    {
      rate: "78%",
      count: 156,
      collected: "₹62,000",
      target: "₹75,000",
    },
    {
      rate: "88%",
      count: 112,
      collected: "₹42,000",
      target: "₹45,000",
    },
    {
      rate: "95%",
      count: 85,
      collected: "₹35,000",
      target: "₹35,000",
    },
  ];

  const collectionsData = {
    Team: [
      {
        ptp: "90%",
        keptRate: "85%",
        count: 145,
        collected: "₹1,20,000",
        target: "₹1,50,001",
      },
      {
        ptp: "82%",
        keptRate: "78%",
        count: 110,
        collected: "₹95,000",
        target: "₹1,20,000",
      },
      {
        ptp: "95%",
        keptRate: "92%",
        count: 180,
        collected: "₹1,60,000",
        target: "₹1,60,000",
      },
      {
        ptp: "75%",
        keptRate: "70%",
        count: 90,
        collected: "₹75,000",
        target: "₹1,00,000",
      },
      {
        ptp: "88%",
        keptRate: "84%",
        count: 130,
        collected: "₹1,10,000",
        target: "₹1,30,000",
      },
    ],
    DCA: [
      {
        ptp: "85%",
        keptRate: "80%",
        count: 200,
        collected: "₹2,00,000",
        target: "₹2,50,000",
      },
      {
        ptp: "78%",
        keptRate: "72%",
        count: 150,
        collected: "₹1,50,000",
        target: "₹2,00,000",
      },
      {
        ptp: "92%",
        keptRate: "88%",
        count: 220,
        collected: "₹2,80,000",
        target: "₹3,00,000",
      },
      {
        ptp: "70%",
        keptRate: "65%",
        count: 120,
        collected: "₹1,00,000",
        target: "₹1,50,000",
      },
      {
        ptp: "85%",
        keptRate: "80%",
        count: 180,
        collected: "₹1,90,000",
        target: "₹2,20,000",
      },
    ],
    Campaigns: [
      {
        ptp: "88%",
        keptRate: "82%",
        count: 160,
        collected: "₹1,40,000",
        target: "₹1,60,000",
      },
      {
        ptp: "80%",
        keptRate: "75%",
        count: 130,
        collected: "₹1,10,000",
        target: "₹1,40,000",
      },
      {
        ptp: "94%",
        keptRate: "90%",
        count: 190,
        collected: "₹2,00,000",
        target: "₹2,10,000",
      },
      {
        ptp: "72%",
        keptRate: "68%",
        count: 100,
        collected: "₹90,000",
        target: "₹1,20,000",
      },
      {
        ptp: "86%",
        keptRate: "81%",
        count: 150,
        collected: "₹1,30,000",
        target: "₹1,50,000",
      },
    ],
  };

  const complianceData = {
    Team: [
      { qc: "98%", aht: "4m 12s", flow: "100%", calls: 1250 },
      { qc: "95%", aht: "3m 45s", flow: "98%", calls: 1100 },
      { qc: "92%", aht: "5m 20s", flow: "95%", calls: 950 },
      { qc: "99%", aht: "4m 05s", flow: "100%", calls: 1400 },
      { qc: "96%", aht: "3m 55s", flow: "97%", calls: 1300 },
    ],
    DCA: [
      { qc: "94%", aht: "5m 10s", flow: "96%", calls: 1500 },
      { qc: "92%", aht: "4m 50s", flow: "94%", calls: 1350 },
      { qc: "90%", aht: "5m 30s", flow: "92%", calls: 1200 },
      { qc: "95%", aht: "4m 45s", flow: "97%", calls: 1600 },
      { qc: "93%", aht: "5m 00s", flow: "95%", calls: 1450 },
    ],
  };

  const strategyScoresData = {
    Organization: [
      { opening: "89%", negotiation: "77%", closing: "93%" },
      { opening: "91%", negotiation: "83%", closing: "86%" },
      { opening: "86%", negotiation: "79%", closing: "89%" },
      { opening: "93%", negotiation: "81%", closing: "91%" },
      { opening: "88%", negotiation: "77%", closing: "90%" },
    ],
    Team: [
      { opening: "88%", negotiation: "75%", closing: "92%" },
      { opening: "90%", negotiation: "82%", closing: "85%" },
      { opening: "85%", negotiation: "78%", closing: "88%" },
      { opening: "92%", negotiation: "80%", closing: "90%" },
      { opening: "87%", negotiation: "76%", closing: "89%" },
    ],
    DCA: [
      { opening: "82%", negotiation: "70%", closing: "85%" },
      { opening: "85%", negotiation: "75%", closing: "88%" },
      { opening: "80%", negotiation: "72%", closing: "82%" },
      { opening: "88%", negotiation: "78%", closing: "86%" },
      { opening: "84%", negotiation: "74%", closing: "84%" },
    ],
  };

  const trendsChartData = {
    Daily: {
      categories: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
      data: [4000, 3000, 2000, 2780, 1890, 2390, 3490],
    },
    Weekly: {
      categories: ["Week 1", "Week 2", "Week 3", "Week 4"],
      data: [15000, 18000, 12000, 20000],
    },
    Monthly: {
      categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun"],
      data: [60000, 55000, 70000, 65000, 75000, 80000],
    },
    Quarterly: {
      categories: ["Q1", "Q2", "Q3", "Q4"],
      data: [185000, 220000, 200000, 240000],
    },
  };

  const trendsOptions = {
    chart: {
      type: "column",
      height: "300px",
    },
    title: {
      text: "",
    },
    credits: {
      enabled: false,
    },
    xAxis: {
      categories: trendsChartData[trendsFilter].categories,
      gridLineWidth: 0,
    },
    yAxis: {
      gridLineColor: "transparent",
      title: {
        text: "Collections",
      },
    },
    plotOptions: {
      column: {
        borderRadius: 5,
      },
    },
    series: [
      {
        name: "Collections",
        data: trendsChartData[trendsFilter].data,
        color: "#7CB5EC",
      },
    ],
  };

  const cxTrendsData = {
    Organization: {
      categories: [
        "2023-01-01",
        "2023-01-05",
        "2023-01-10",
        "2023-01-15",
        "2023-01-20",
        "2023-01-25",
        "2023-01-30",
        "2023-02-04",
        "2023-02-09",
        "2023-02-14",
      ],
      data: [
        ["2023-01-01", 85],
        ["2023-01-05", 87],
        ["2023-01-10", 82],
        ["2023-01-15", 88],
        ["2023-01-20", 90],
        ["2023-01-25", 86],
        ["2023-01-30", 92],
        ["2023-02-04", 89],
        ["2023-02-09", 93],
        ["2023-02-14", 88],
      ],
    },
    Team: {
      categories: [
        "2023-01-01",
        "2023-01-05",
        "2023-01-10",
        "2023-01-15",
        "2023-01-20",
        "2023-01-25",
        "2023-01-30",
        "2023-02-04",
        "2023-02-09",
        "2023-02-14",
      ],
      data: [
        ["2023-01-01", 75],
        ["2023-01-05", 78],
        ["2023-01-10", 80],
        ["2023-01-15", 72],
        ["2023-01-20", 85],
        ["2023-01-25", 82],
        ["2023-01-30", 79],
        ["2023-02-04", 88],
        ["2023-02-09", 84],
        ["2023-02-14", 86],
      ],
    },
    DCA: {
      categories: [
        "2023-01-01",
        "2023-01-05",
        "2023-01-10",
        "2023-01-15",
        "2023-01-20",
        "2023-01-25",
        "2023-01-30",
        "2023-02-04",
        "2023-02-09",
        "2023-02-14",
      ],
      data: [
        ["2023-01-01", 65],
        ["2023-01-05", 68],
        ["2023-01-10", 70],
        ["2023-01-15", 62],
        ["2023-01-20", 65],
        ["2023-01-25", 68],
        ["2023-01-30", 72],
        ["2023-02-04", 69],
        ["2023-02-09", 74],
        ["2023-02-14", 76],
      ],
    },
  };

  const cxTrendOptions = {
    chart: {
      type: "scatter",
      height: "300px",
    },
    title: {
      text: "",
    },
    credits: {
      enabled: false,
    },
    xAxis: {
      categories: cxTrendsData[cxTrendsFilter].categories,
      gridLineWidth: 0,
      type: "datetime",
      dateTimeLabelFormats: {
        month: "%e. %b",
        year: "%Y",
      },
      title: {
        text: "Date",
      },
    },
    yAxis: {
      gridLineColor: "transparent",
      title: {
        text: "Aggregated CX Score",
      },
      plotLines: [
        {
          value: 0,
          width: 0,
          color: "#808080",
        },
      ],
    },
    legend: {
      enabled: false,
    },
    exporting: {
      enabled: false,
    },
    plotOptions: {
      series: {
        lineWidth: 1,
      },
    },
    series: [
      {
        data: cxTrendsData[cxTrendsFilter].data,
        name: "CX Score",
        color: "#271078",
      },
    ],
  };

  const intentData = {
    Organization: {
      categories: [
        "2026-02-01",
        "2026-02-02",
        "2026-02-03",
        "2026-02-04",
        "2026-02-05",
        "2026-02-06",
        "2026-02-07",
      ],
      positive: [80, 85, 75, 90, 88, 92, 85],
      negative: [20, 15, 25, 10, 12, 8, 15],
    },
    Team: {
      categories: [
        "2026-02-01",
        "2026-02-02",
        "2026-02-03",
        "2026-02-04",
        "2026-02-05",
        "2026-02-06",
        "2026-02-07",
      ],
      positive: [70, 75, 65, 80, 78, 85, 76],
      negative: [30, 25, 35, 20, 22, 15, 24],
    },
    DCA: {
      categories: [
        "2026-02-01",
        "2026-02-02",
        "2026-02-03",
        "2026-02-04",
        "2026-02-05",
        "2026-02-06",
        "2026-02-07",
      ],
      positive: [60, 65, 55, 70, 68, 75, 66],
      negative: [40, 35, 45, 30, 32, 25, 34],
    },
  };

  const intentOptions = {
    chart: {
      type: "column",
      height: "300px",
    },
    title: {
      text: "",
    },
    credits: {
      enabled: false,
    },
    xAxis: {
      categories: intentData[intentFilter].categories,
      gridLineWidth: 0,
    },
    yAxis: [
      {
        className: "highcharts-color-0",
        title: {
          text: "Positive Intent",
        },
        gridLineColor: "transparent",
      },
      {
        className: "highcharts-color-1",
        opposite: true,
        title: {
          text: "Negative Intent",
        },
        gridLineColor: "transparent",
      },
    ],
    plotOptions: {
      column: {
        borderRadius: 5,
      },
    },
    series: [
      {
        name: "Positive",
        data: intentData[intentFilter].positive,
        color: "#7CB5EC",
      },
      {
        name: "Negative",
        data: intentData[intentFilter].negative,
        color: "#434348",
        yAxis: 1,
      },
    ],
  };

  return (
    <div className="dashboard-body">
      <Header />
      <NavBar />
      <NotificationContainer />
      <section className="page-body" style={{ paddingTop: "15px" }}>
        <div className="section-one clearfix" style={{ paddingRight: "0px" }}>
          <div className="container-fluid">
            <Masonry
              breakpointCols={2}
              className="my-masonry-grid gap-3"
              columnClassName="my-masonry-grid_column"
            >
              <div>
                <div className="assistant" style={{ minHeight: "50px" }}>
                  <div style={{ paddingTop: "20px", paddingLeft: "20px" }}>
                    <label
                      style={{ fontSize: "20px", color: "#271078" }}
                      className=" flex  items-center"
                    >
                      {" "}
                      <span className=" mr-4">
                        <BiFile style={{ fontSize: "25px" }} />{" "}
                      </span>
                      Recent Reports
                    </label>
                  </div>
                  <div style={{ minHeight: "4px", overflow: "auto" }}>
                    <div className="accordion">
                      <div className="call-table" style={{ minHeight: "10px" }}>
                        <table className="ss">
                          <thead className="">
                            <tr>
                              <th>
                                <p className=" text-center">Kept Rate</p>
                              </th>
                              <th>
                                <p className=" text-center">PTP Count</p>
                              </th>
                              <th>
                                <p className=" text-center">Collected</p>
                              </th>
                              <th>
                                <p className=" text-center">Target </p>
                              </th>
                            </tr>
                          </thead>

                          <tbody>
                            {recentReportsData.map((row, index) => {
                              return (
                                <tr
                                  className="tableRow cursor-pointer"
                                  key={index}
                                >
                                  <td>
                                    <a
                                      className=" whitespace-nowrap"
                                      style={{ color: "black" }}
                                    >
                                      {row.rate}
                                    </a>
                                  </td>
                                  <td>
                                    <a
                                      className=" whitespace-nowrap"
                                      style={{ color: "black" }}
                                    >
                                      {row.count}
                                    </a>
                                  </td>
                                  <td>
                                    <a
                                      className=" whitespace-nowrap"
                                      style={{ color: "black" }}
                                    >
                                      {row.collected}
                                    </a>
                                  </td>
                                  <td>
                                    <a
                                      className=" whitespace-nowrap"
                                      style={{ color: "black" }}
                                    >
                                      {row.target}
                                    </a>
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div className="assistant" style={{ minHeight: "50px" }}>
                  <div
                    style={{
                      paddingTop: "20px",
                      paddingLeft: "20px",
                      paddingRight: "20px",
                    }}
                    className=" flex justify-between items-center"
                  >
                    <label
                      style={{ fontSize: "20px", color: "#271078" }}
                      className=" flex  items-center"
                    >
                      {" "}
                      <span className=" mr-4">
                        <BiMoney style={{ fontSize: "25px" }} />{" "}
                      </span>
                      Collections
                    </label>
                    <select
                      style={{ border: "1px solid lightgray" }}
                      className=" px-4 py-2"
                      value={collectionFilter}
                      onChange={handleCollectionChange}
                    >
                      <option value="Team">Team </option>
                      <option value="DCA">DCA</option>
                      <option value="Campaigns">Campaigns</option>
                    </select>
                  </div>
                  <div style={{ minHeight: "4px", overflow: "auto" }}>
                    <div className="accordion">
                      <div className="call-table" style={{ minHeight: "10px" }}>
                        {collectionLoading ? (
                          <div style={{ textAlign: "center", padding: "20px" }}>
                            <ClipLoader color="#2056FF" size="50px" />
                          </div>
                        ) : (
                          <table className="ss">
                            <thead className="">
                              <tr>
                                <th>
                                  <p className=" text-center">PTP</p>
                                </th>
                                <th>
                                  <p className=" text-center">Kept Rate</p>
                                </th>
                                <th>
                                  <p className=" text-center">PTP Count</p>
                                </th>
                                <th>
                                  <p className=" text-center">Collected </p>
                                </th>
                                <th>
                                  <p className=" text-center">Target </p>
                                </th>
                              </tr>
                            </thead>

                            <tbody>
                              {(collectionsData[collectionFilter] || []).map(
                                (row, index) => {
                                  return (
                                    <tr
                                      className="tableRow cursor-pointer"
                                      key={index}
                                    >
                                      <td>
                                        <a
                                          className=" whitespace-nowrap"
                                          style={{ color: "black" }}
                                        >
                                          {row.ptp}
                                        </a>
                                      </td>
                                      <td>
                                        <a
                                          className=" whitespace-nowrap"
                                          style={{ color: "black" }}
                                        >
                                          {row.keptRate}
                                        </a>
                                      </td>
                                      <td>
                                        <a
                                          className=" whitespace-nowrap"
                                          style={{ color: "black" }}
                                        >
                                          {row.count}
                                        </a>
                                      </td>
                                      <td>
                                        <a
                                          className=" whitespace-nowrap"
                                          style={{ color: "black" }}
                                        >
                                          {row.collected}
                                        </a>
                                      </td>
                                      <td>
                                        <a
                                          className=" whitespace-nowrap"
                                          style={{ color: "black" }}
                                        >
                                          {row.target}
                                        </a>
                                      </td>
                                    </tr>
                                  );
                                },
                              )}
                            </tbody>
                          </table>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div className="assistant" style={{ minHeight: "50px" }}>
                  <div
                    style={{
                      paddingTop: "20px",
                      paddingLeft: "20px",
                      paddingRight: "20px",
                    }}
                    className=" flex justify-between items-center"
                  >
                    <label
                      style={{ fontSize: "20px", color: "#271078" }}
                      className=" flex  items-center"
                    >
                      {" "}
                      <span className=" mr-4">
                        <BiCheckShield style={{ fontSize: "25px" }} />{" "}
                      </span>
                      Compliance & Quality
                    </label>
                    <select
                      style={{ border: "1px solid lightgray" }}
                      className=" px-4 py-2"
                      value={complianceFilter}
                      onChange={handleComplianceChange}
                    >
                      <option value="Team">Team </option>
                      <option value="DCA">DCA</option>
                    </select>
                  </div>
                  <div style={{ minHeight: "4px", overflow: "auto" }}>
                    <div className="accordion">
                      <div className="call-table" style={{ minHeight: "10px" }}>
                        {complianceLoading ? (
                          <div style={{ textAlign: "center", padding: "20px" }}>
                            <ClipLoader color="#2056FF" size="50px" />
                          </div>
                        ) : (
                          <table className="ss">
                            <thead className="">
                              <tr>
                                <th>
                                  <p className=" text-center">QC</p>
                                </th>
                                <th>
                                  <p className=" text-center">AHT</p>
                                </th>
                                <th>
                                  <p className=" text-center">Flow Rate</p>
                                </th>
                                <th>
                                  <p className=" text-center">Total Calls </p>
                                </th>
                              </tr>
                            </thead>

                            <tbody>
                              {(complianceData[complianceFilter] || []).map(
                                (row, index) => {
                                  return (
                                    <tr
                                      className="tableRow cursor-pointer"
                                      key={index}
                                    >
                                      <td>
                                        <a
                                          className=" whitespace-nowrap"
                                          style={{ color: "black" }}
                                        >
                                          {row.qc}
                                        </a>
                                      </td>
                                      <td>
                                        <a
                                          className=" whitespace-nowrap"
                                          style={{ color: "black" }}
                                        >
                                          {row.aht}
                                        </a>
                                      </td>
                                      <td>
                                        <a
                                          className=" whitespace-nowrap"
                                          style={{ color: "black" }}
                                        >
                                          {row.flow}
                                        </a>
                                      </td>
                                      <td>
                                        <a
                                          className=" whitespace-nowrap"
                                          style={{ color: "black" }}
                                        >
                                          {row.calls}
                                        </a>
                                      </td>
                                    </tr>
                                  );
                                },
                              )}
                            </tbody>
                          </table>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div className="assistant" style={{ minHeight: "50px" }}>
                  <div
                    style={{
                      paddingTop: "20px",
                      paddingLeft: "20px",
                      paddingRight: "20px",
                    }}
                    className=" flex justify-between items-center"
                  >
                    <label
                      style={{ fontSize: "20px", color: "#271078" }}
                      className=" flex  items-center"
                    >
                      {" "}
                      <span className=" mr-4">
                        <BiBulb style={{ fontSize: "25px" }} />{" "}
                      </span>
                      Collections Strategy Scores
                    </label>
                    <select
                      style={{ border: "1px solid lightgray" }}
                      className=" px-4 py-2"
                      value={strategyScoreFilter}
                      onChange={handleStrategyScoreChange}
                    >
                      <option value="Organization">Organization</option>
                      <option value="Team">Team </option>
                      <option value="DCA">DCA</option>
                    </select>
                  </div>
                  <div style={{ minHeight: "4px", overflow: "auto" }}>
                    <div className="accordion">
                      <div className="call-table" style={{ minHeight: "10px" }}>
                        {strategyScoreLoading ? (
                          <div style={{ textAlign: "center", padding: "20px" }}>
                            <ClipLoader color="#2056FF" size="50px" />
                          </div>
                        ) : (
                          <table className="ss">
                            <thead className="">
                              <tr>
                                <th>
                                  <p className=" text-center">Call Opening</p>
                                </th>
                                <th>
                                  <p className=" text-center">
                                    Negotiations Strategy
                                  </p>
                                </th>
                                <th>
                                  <p className=" text-center">Call Closing</p>
                                </th>
                              </tr>
                            </thead>

                            <tbody>
                              {(
                                strategyScoresData[strategyScoreFilter] || []
                              ).map((row, index) => (
                                <tr
                                  className="tableRow cursor-pointer"
                                  key={index}
                                >
                                  <td>
                                    <a
                                      className=" whitespace-nowrap"
                                      style={{ color: "black" }}
                                    >
                                      {row.opening}
                                    </a>
                                  </td>
                                  <td>
                                    <a
                                      className=" whitespace-nowrap"
                                      style={{ color: "black" }}
                                    >
                                      {row.negotiation}
                                    </a>
                                  </td>
                                  <td>
                                    <a
                                      className=" whitespace-nowrap"
                                      style={{ color: "black" }}
                                    >
                                      {row.closing}
                                    </a>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div className="assistant" style={{ minHeight: "50px" }}>
                  <div
                    style={{
                      paddingTop: "20px",
                      paddingLeft: "20px",
                      paddingRight: "20px",
                    }}
                    className=" flex justify-between items-center"
                  >
                    <label
                      style={{ fontSize: "20px", color: "#271078" }}
                      className=" flex  items-center"
                    >
                      {" "}
                      <span className=" mr-4">
                        <BiBarChartAlt2 style={{ fontSize: "25px" }} />{" "}
                      </span>
                      Trends & Analysis
                    </label>
                    <select
                      style={{ border: "1px solid lightgray" }}
                      className=" px-4 py-2"
                      value={trendsFilter}
                      onChange={handleTrendsChange}
                    >
                      <option value="Daily">Daily</option>
                      <option value="Weekly">Weekly</option>
                      <option value="Monthly">Monthly</option>
                      <option value="Quarterly">Quarterly</option>
                    </select>
                  </div>
                  <div
                    style={{
                      minHeight: "300px",
                      overflow: "auto",
                      padding: "20px",
                    }}
                  >
                    {trendsLoading ? (
                      <div style={{ textAlign: "center", padding: "20px" }}>
                        <ClipLoader color="#2056FF" size="50px" />
                      </div>
                    ) : (
                      <HighchartsReact
                        highcharts={Highcharts}
                        options={trendsOptions}
                      />
                    )}
                  </div>
                </div>
              </div>
              <div>
                <div className="assistant" style={{ minHeight: "50px" }}>
                  <div
                    style={{
                      paddingTop: "20px",
                      paddingLeft: "20px",
                      paddingRight: "20px",
                    }}
                    className=" flex justify-between items-center"
                  >
                    <label
                      style={{ fontSize: "20px", color: "#271078" }}
                      className=" flex  items-center"
                    >
                      {" "}
                      <span className=" mr-4">
                        <BiTrendingUp style={{ fontSize: "25px" }} />{" "}
                      </span>
                      CX Trends
                    </label>
                    <select
                      style={{ border: "1px solid lightgray" }}
                      className=" px-4 py-2"
                      value={cxTrendsFilter}
                      onChange={handleCxTrendsChange}
                    >
                      <option value="Organization">Organization</option>
                      <option value="Team">Team </option>
                      <option value="DCA">DCA</option>
                    </select>
                  </div>
                  <div
                    style={{
                      minHeight: "300px",
                      overflow: "auto",
                      padding: "20px",
                    }}
                  >
                    {cxTrendsLoading ? (
                      <div style={{ textAlign: "center", padding: "20px" }}>
                        <ClipLoader color="#2056FF" size="50px" />
                      </div>
                    ) : (
                      <HighchartsReact
                        highcharts={Highcharts}
                        options={cxTrendOptions}
                      />
                    )}
                  </div>
                </div>
              </div>
              <div>
                <div className="assistant" style={{ minHeight: "50px" }}>
                  <div
                    style={{
                      paddingTop: "20px",
                      paddingLeft: "20px",
                      paddingRight: "20px",
                    }}
                    className=" flex justify-between items-center"
                  >
                    <label
                      style={{ fontSize: "20px", color: "#271078" }}
                      className=" flex  items-center"
                    >
                      {" "}
                      <span className=" mr-4">
                        <i
                          className="fa fa-bar-chart"
                          aria-hidden="true"
                          style={{ fontSize: "25px" }}
                        ></i>{" "}
                      </span>
                      Intent Analysis
                    </label>
                    <select
                      style={{ border: "1px solid lightgray" }}
                      className=" px-4 py-2"
                      value={intentFilter}
                      onChange={handleIntentChange}
                    >
                      <option value="Organization">Organization</option>
                      <option value="Team">Team </option>
                      <option value="DCA">DCA</option>
                    </select>
                  </div>
                  <div
                    style={{
                      minHeight: "300px",
                      overflow: "auto",
                      padding: "20px",
                    }}
                  >
                    {intentLoading ? (
                      <div style={{ textAlign: "center", padding: "20px" }}>
                        <ClipLoader color="#2056FF" size="50px" />
                      </div>
                    ) : (
                      <HighchartsReact
                        highcharts={Highcharts}
                        options={intentOptions}
                      />
                    )}
                  </div>
                </div>
              </div>
            </Masonry>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default LobHome;
